import { AbstractApiService } from '../abstractions/AbstractApiService';
import { OnRequestError, OnRequestSuccess } from './Responses';

export class IdentityService extends AbstractApiService {
    constructor() {
        super();
    }

    public LogIn({
        login,
        password,
        token,
        token2,
    }: {
        login: string,
        password: string,
        token?: string,
        token2?: string,
    }, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        let loginData = {
            Email: login,
            Password: password,
            Token: token,
            Token2: token2,
        };
        this.Post('api/account/login', loginData, onSuccess, onError);
    }

    public GetProfileInfo(onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/account/info', onSuccess, onError);
    }

    public LogOut(onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/account/logout', {}, onSuccess, onError);
    }

    public SigninFacebook(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        let provider = 'Facebook';
        this.Post('ExternalAccount/ExternalLogin?returnUrl=%2F&provider=' + provider, {}, onSuccess, onError);
    }

    //public CallBack(model: any, onSuccess: OnRequestSuccess, onError: OnRequestError) {
    //    this.Post('api/account/ExternalLoginCallback', model, onSuccess, onError);
    //}

    public AcceptStatute(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/account/acceptstatute', onSuccess, onError);
    }

    public GetSchedulerRequests(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/account/getschedulerrequests', onSuccess, onError);
    }
    
    public AcceptStatuteCustomer(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('ExternalAccount/acceptstatutecustomer', onSuccess, onError);
    }
}


// WEBPACK FOOTER //
// ./src/services/IdentityService.tsx